import { baseApi } from 'services/baseApi';
import { AppConstants } from 'constants/index';
import { TimeZonesType } from 'app/timeZone/types';

export const timeZoneApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTimeZones: builder.query<TimeZonesType, void>({
      query: () => {
        const { BrandAdmin, Brand, TimeZones } = AppConstants.api;
        return {
          url: [BrandAdmin, Brand, TimeZones],
        };
      },
      keepUnusedDataFor: Infinity,
    }),
  }),
});

export const { useGetTimeZonesQuery } = timeZoneApi;
